/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A2Inputs */

const es_marketplace_seo_spain_faq_a2 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Las embarcaciones de recreo de hasta 15 CV pueden alquilarse sin titulación en España. También puedes reservar cualquier barco con patrón si no tienes carnet.`)
};

const gl_marketplace_seo_spain_faq_a2 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si. As embarcacións de recreo de ata 15 CV pódense aluguer sen titulación en España. Tamén podes reservar calquera barco con patrón se non tes carnet.`)
};

const en_marketplace_seo_spain_faq_a2 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Recreational boats up to 15 HP can be rented without a licence in Spain. You can also book any boat with a skipper if you have no certificate.`)
};

/**
* | output |
* | --- |
* | "Yes. Recreational boats up to 15 HP can be rented without a licence in Spain. You can also book any boat with a skipper if you have no certificate." |
*
* @param {Marketplace_Seo_Spain_Faq_A2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a2 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a2(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a2(inputs)
	return es_marketplace_seo_spain_faq_a2(inputs)
});